<template>
  <a-modal
    width="900px"
    title="确认计算结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，
      <span v-if="calculationAbnormal.length" style="color: red;">部分结果异常或有误，建议返回检查</span>
      <span v-else>计算结果如下</span>:
    </div>
    <br>
    <h3>采食及耗料</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span class="title">均采食量（kg/天）</span>
          <a-icon v-if="isAbnormal('avgFeedCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgFeedCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgFeedCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span >均干物质采食量（kg/天）</span>
          <a-icon v-if="isAbnormal('avgDryFeedCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgDryFeedCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgDryFeedCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>均日粮成本（元/天）</span>
          <a-icon v-if="isAbnormal('avgDayCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgDayCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgDayCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段总耗料（kg）</span>
          <a-icon v-if="isAbnormal('stageCostTotal')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageCostTotal') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageCostTotal?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段饲喂成本（元）</span>
          <a-icon v-if="isAbnormal('stageFeedCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageFeedCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageFeedCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    <br>
    <h3>生产结果</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>饲喂天数（天）</span>
          <a-icon v-if="isAbnormal('feedTotalDay')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('feedTotalDay') ? 'abnormalBox' : 'box'">
            {{calculationResult.feedTotalDay?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>死淘率（%）</span>
          <a-icon v-if="isAbnormal('deadDisuseRatio')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('deadDisuseRatio') ? 'abnormalBox' : 'box'">
            {{calculationResult.deadDisuseRatio?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段总增重（kg）</span>
          <a-icon v-if="isAbnormal('stageTotalWeightIncrement')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageTotalWeightIncrement') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageTotalWeightIncrement?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>平均日增重（kg/头）</span>
          <a-icon v-if="isAbnormal('avgWeightIncrementDay')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgWeightIncrementDay') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgWeightIncrementDay?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>料肉比(FCR)</span>
          <a-icon v-if="isAbnormal('weightCostRatio')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('weightCostRatio') ? 'abnormalBox' : 'box'">
            {{calculationResult.weightCostRatio?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>造肉成本（元/kg）</span>
          <a-icon v-if="isAbnormal('mealProductCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('mealProductCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.mealProductCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    <br>
    <h3>经济效益</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>毛收入（元/头/天）</span>
          <a-icon v-if="isAbnormal('netProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('netProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.netProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段利润（元/头）</span>
          <a-icon v-if="isAbnormal('stageProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>总毛收入（元/头）</span>
          <a-icon v-if="isAbnormal('totalNetProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('totalNetProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.totalNetProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>本批毛收入（元）</span>
          <a-icon v-if="isAbnormal('currentNetProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('currentNetProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.currentNetProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    </a-modal>
</template>

<script>
export default {
  props:['visible','calculationResult','calculationAbnormal'],
  data(){
    return{}
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('calculationConfirm')
    },
    handleCancel() {
      this.$emit('calculationAbnormalInit')
      this.$emit('isShow', false)
    },
    isAbnormal(value){
      return this.calculationAbnormal.includes(value)
    }
  }
}
</script>

<style lang='scss'>
.result{
  background-color:whitesmoke;
  padding: 3px;
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
  .abnormalBox{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
    color: red;
  }
  .anticon{
    color: orange 
  }
}
</style>